import * as yup from "yup";

const addNewProductValidator = yup.object().shape({
	name: yup.string().required("Product name is required."),
	localName: yup.string().required("Please specify a local name."),
	category: yup.string().required("Choose a category."),
	rack: yup.string().required("Rack location is required."),
	shelf: yup.string().required("Specify which shelf the product goes to."),
});

export default addNewProductValidator;
